import React, { useState } from 'react';
import './LoginPage.css';

function LoginPage({ onClose }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async () => {
    if (username && password) {
      // Send login request to main API
      fetch('https://08yvli9kn1.execute-api.us-east-1.amazonaws.com/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: username, password }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            // Login successful, store token
            localStorage.setItem('token', data.data.token);
            alert('Login successful!');
            // Redirect to admin or dashboard
            window.location.href = '/'; // or wherever
          } else {
            alert('Invalid email or password');
          }
        })
        .catch(error => {
          console.error('Login error:', error);
          alert('Login failed');
        });
    } else {
      alert('Please enter username and password');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="login-container">
          <div className="login-form">
            <h2 className="login-title">Login</h2>
            <div className="input-group">
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="login-input"
              />
            </div>
            <div className="input-group">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="login-input"
              />
            </div>
            <button onClick={handleLogin} className="login-button">Log In</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;